var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.offerLoading &&
    _vm.localPrivacyOverlayButtonText &&
    _vm.localPrivacyOverlayButtonText.length > 0 &&
    _vm.localPrivacyOverlayMessage &&
    _vm.localPrivacyOverlayMessage.length > 0
      ? _c(
          "div",
          { class: _vm.$style.overlay, attrs: { id: "pitchOverlay" } },
          [
            _c("div", { class: _vm.$style.overlayContent }, [
              _c("p", [_vm._v(_vm._s(_vm.localPrivacyOverlayMessage))]),
              _vm._v(" "),
              _c(
                "button",
                {
                  class: _vm.$style.closeButton,
                  on: { click: _vm.closeOverlay }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.localPrivacyOverlayButtonText.toUpperCase()) +
                      "\n      "
                  )
                ]
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.offerLoading
      ? _c("div", { class: _vm.$style.spinnerWrapper }, [_c("NsSpinner")], 1)
      : _c(
          "article",
          { class: _vm.$style.productOffer },
          [
            !_vm.showOffer && !_vm.productsLoading
              ? [
                  _vm.offerNotFound
                    ? _c("section", { class: _vm.$style.offerNotFound }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.localTranslations.offerNotFound) +
                            "\n      "
                        )
                      ])
                    : _vm.offerExpired
                    ? _c("section", { class: _vm.$style.offerExpired }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.localTranslations.offerExpired) +
                            "\n      "
                        )
                      ])
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.productsLoading
              ? _c(
                  "div",
                  { class: _vm.$style.spinnerWrapper },
                  [_c("NsSpinner")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showOffer
              ? _c("section", { class: _vm.$style.offerTitleMessaging }, [
                  _c("div", { class: _vm.$style.offerMessaging }, [
                    _c("h2", { class: _vm.$style.offerTitle }, [
                      _vm._v(_vm._s(_vm.localTranslations.welcome))
                    ]),
                    _vm._v(" "),
                    _c("p", { class: _vm.$style.offerMessage }, [
                      !_vm.offer.isGroupOffer
                        ? _c("span", [_vm._v(_vm._s(_vm.offer.name))])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.offer.isGroupOffer && _vm.offer.countryCode === "JP"
                        ? _c("span", [
                            _vm._v("\n            さん,\n          ")
                          ])
                        : !_vm.offer.isGroupOffer &&
                          _vm.offer.countryCode !== "JP"
                        ? _c("span", [_vm._v(",\n          ")])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.offer.greeting))])
                    ]),
                    _vm._v(" "),
                    _c("p", { class: _vm.$style.storePreferredName }, [
                      _vm._v(
                        "\n          - " +
                          _vm._s(_vm.storePreferredName) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.approvedMessage
                      ? _c("div", [
                          _c("hr"),
                          _vm._v(" "),
                          _c("div", { class: _vm.$style.approvedMessage }, [
                            _vm._v(_vm._s(_vm.approvedMessage))
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "section",
              {
                class: [
                  _vm.$style.offerBody,
                  ((_obj = {}),
                  (_obj[_vm.$style.showOffer] = _vm.showOffer),
                  _obj)
                ]
              },
              [
                _vm.showOffer
                  ? _c("div", { class: _vm.$style.offerPurchaseAll }, [
                      _c(
                        "div",
                        { class: _vm.$style.offerTotalContainer },
                        [
                          _vm.offerTotalBeforeHtml
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.offerTotalBeforeHtml))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showOfferTotal
                            ? [
                                !_vm.hideDiscount
                                  ? _c(
                                      "span",
                                      { class: _vm.$style.originalOfferTotal },
                                      [
                                        _c("NsCurrency", {
                                          attrs: {
                                            amount: _vm.originalOfferTotal,
                                            "strike-through": ""
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { class: _vm.$style.offerTotal },
                                  [
                                    _c("NsCurrency", {
                                      attrs: { amount: _vm.offerTotal }
                                    })
                                  ],
                                  1
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.offerTotalAfterHtml
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.offerTotalAfterHtml))
                              ])
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      !_vm.hideDiscount && _vm.showOfferSavings
                        ? _c(
                            "div",
                            { class: _vm.$style.offerSavingsContainer },
                            [
                              _vm.offerSavingsBeforeHtml
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.offerSavingsBeforeHtml))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                { class: _vm.$style.offerSavings },
                                [
                                  _c("NsCurrency", {
                                    attrs: { amount: _vm.offerSavings }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.offerSavingsAfterHtml
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.offerSavingsAfterHtml))
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { class: _vm.$style.offerAction }, [
                        _c(
                          "button",
                          {
                            staticClass: "primary-solid fluid",
                            class: _vm.$style.button,
                            attrs: { disabled: _vm.disableAddAll },
                            on: { click: _vm.addFullOfferToCart }
                          },
                          [
                            _c("NsIcon", {
                              class: _vm.$style.addToCartIcon,
                              attrs: { "icon-name": "icon-bag" }
                            }),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.localTranslations.addAllItems) +
                                "\n          "
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.totalProducts > 0
                  ? _c(
                      "div",
                      {
                        class: [
                          _vm.$style.offerProducts,
                          _vm.$style["totalProducts" + _vm.totalProducts]
                        ]
                      },
                      _vm._l(Object.keys(_vm.products), function(sku, index) {
                        var _obj
                        return _c("NsProductCard", {
                          key: index,
                          class: [
                            _vm.$style.offerProduct,
                            ((_obj = {}),
                            (_obj[_vm.$style.invalid] = !!_vm.products[sku]
                              .invalid),
                            _obj)
                          ],
                          attrs: {
                            sku: sku,
                            quantity: _vm.products[sku].requestedQuantity,
                            "mobile-side-by-side": "",
                            "hide-favorites": ""
                          },
                          on: {
                            "active-sku": function(activeSku) {
                              return _vm.modifyProduct(sku, {
                                activeSku: activeSku
                              })
                            },
                            availability: function(availability) {
                              return _vm.modifyProduct(sku, {
                                availability: availability
                              })
                            },
                            "product-update": _vm.handleProductUpdate,
                            "variant-select": function(results) {
                              return _vm.handleVariantSelected(results, sku)
                            }
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showOffer && !_vm.hideBottomPurchaseAll
                  ? _c("div", { class: _vm.$style.offerPurchaseAll }, [
                      _c(
                        "div",
                        { class: _vm.$style.offerTotalContainer },
                        [
                          _vm.offerTotalBeforeHtml
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.offerTotalBeforeHtml))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showOfferTotal
                            ? [
                                !_vm.hideDiscount
                                  ? _c(
                                      "span",
                                      { class: _vm.$style.originalOfferTotal },
                                      [
                                        _c("NsCurrency", {
                                          attrs: {
                                            amount: _vm.originalOfferTotal,
                                            "strike-through": ""
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { class: _vm.$style.offerTotal },
                                  [
                                    _c("NsCurrency", {
                                      attrs: { amount: _vm.offerTotal }
                                    })
                                  ],
                                  1
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.offerTotalAfterHtml
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.offerTotalAfterHtml))
                              ])
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      !_vm.hideDiscount && _vm.showOfferSavings
                        ? _c(
                            "div",
                            { class: _vm.$style.offerSavingsContainer },
                            [
                              _vm.offerSavingsBeforeHtml
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.offerSavingsBeforeHtml))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                { class: _vm.$style.offerSavings },
                                [
                                  _c("NsCurrency", {
                                    attrs: { amount: _vm.offerSavings }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.offerSavingsAfterHtml
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.offerSavingsAfterHtml))
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]
            )
          ],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }